import { render, staticRenderFns } from "./rgpManagement.vue?vue&type=template&id=88b1ca44"
import script from "./rgpManagement.vue?vue&type=script&lang=js"
export * from "./rgpManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports